<div id="{{Id}}-Selected" 
  [ngClass]="columnInfoDto.IsReadOnly || dataItem.IsDelete? 'not-allowed can-be-selected' : 'can-be-selected max-h'">
  <span class="splitscreen">
      <span id="{{Id}}-Name" 
        [ngClass]="dataItem.IsDelete? 'left pd-disabled' : 'left'" 
        (click)="clickName()">
        {{formatTimeFrame}}
      </span>
      <span>
        <input type="text"
             #calendarDatePicker="bsDatepicker"
             bsDatepicker
             class="ap-datepicker-select form-control" id="{{Id}} + '-datePicker'"
             name="calendarDatePicker"
             (onShown)="attachTodayButtonHandler()"
             [bsConfig]="bsConfig"
             [dateCustomClasses]="dateCustomClasses"
             [readonly]="false"
             [(ngModel)]="dateValue"
             (bsValueChange)="onCalendarDateChange($event)"
             (ngModelChange)='onValueChange()'
             [placement]="'top'" style="opacity: 0; position: absolute; pointer-events: none;">
        <button style="background: none; padding-top: 3px;" [disabled]="columnInfoDto.IsReadOnly || dataItem.IsDelete"  type="button" class="btn btn-flush toggle-btn toggle-calendar-button"
                (click)="calendarDatePicker.toggle()">
          <mat-icon [matTooltip]="'Date'" class="md-18"
                    id="{{Id}}-calendar-btn">calendar_today
          </mat-icon>
        </button>
      </span>
      <span id="{{Id}}-Icon" class="right">
        <mat-icon  [matTooltip]="'Time Frame'"
        [ngClass]="columnInfoDto.IsReadOnly || dataItem.IsDelete? 'not-allowed' : ''"
        class="pd-float-right mat-icon emds-find-control-icon clickable material-icons mat-ligature-font mat-icon-no-color" (click)="clickIcon()">
        alarm</mat-icon>
      </span>
  </span>
</div>
